// ページ内リンク（a[href^="#"]）をなめらかにスクロールさせる（紙ストロー(9) だけ。Issue #70 の 3 本目）。
// wuSiteResource2 の PaperStraw/SiteCommon.ts の引き取り先。挙動は旧実装どおり:
//   - 500ms・swing・オフセット -10px で jQuery('html,body').animate
//   - history.pushState でハッシュを書き換える（location.hash を触らないので即ジャンプしない）
//   - 移動先の要素が無ければ何もしない（ブラウザ既定の動き）
//   - return false 相当（preventDefault + stopPropagation）
//
// 2026-09-23 実測: 対象の <a> は純正の「ページトップへ」（a.back_to_top href="#container"）に加えて、
// フリーページに本物のページ内リンクがある（/page/1 に 24 本、/page/2 に 20 本、/page/24 /26 /32 に 5 本ずつ）。
// おちゃのこ純正 JS が自前でスクロールさせるのは a.back_to_top と a.anchor_link（jQuery の click ハンドラ。/page/1 では
// 24 本中 2 本）だけで、class の無い素の <a href="#..."> は純正側が触らない（/page/1 の残り 22 本）。
// この動きを消すと素のページ内リンクが「即ジャンプ」に変わる → 捨てずに hook にした。
//
// ★ 2 回走らない: jQuery._data(el, 'events').click が既に付いている <a> には束ねない。
//   - 過渡期（旧バンドルと同居）: 旧実装が jQuery で直接 click を束ねている（全部の <a> に付く）→ hook は何もしない
//   - 旧が消えた後: 純正が束ねている back_to_top / anchor_link だけ付いている → そこは純正に任せ、素の <a> だけ hook が束ねる。
//     旧実装はこの 2 種にも重ねて束ねていた（純正の後に -10px へもう一度 animate）が、hook は重ねない。差は最終位置の 10px だけ
//   - _data が無い jQuery なら判定できないので束ねる（2 回走っても animate はキューに積まれて同じ位置で止まるだけ）

import { afterOldScripts } from '../shared/after-old-scripts'

type JQ = ((sel: string | Element) => { offset(): { top: number } | undefined; animate(p: object, ms: number, e: string): unknown }) & {
  _data?: (el: Element, key: string) => { click?: unknown[] } | undefined
}

export const SCROLL_OFFSET_Y = -10
export const SCROLL_TIME_MS = 500

/** ハッシュ（"#foo"）から移動先の要素。無い・空・不正なら null */
export function resolveAnchorTarget(doc: ParentNode, hash: string): Element | null {
  if (!hash || hash === '#') return null
  try {
    return doc.querySelector(hash)
  } catch {
    return null
  }
}

/** 旧実装（jQuery の click ハンドラ）が既に付いているか */
export function hasJQueryClick(jq: JQ, el: Element): boolean {
  try {
    const ev = jq._data?.(el, 'events')
    return !!ev?.click?.length
  } catch {
    return false
  }
}

export function bindAnchorScroll(doc: Document, jq: JQ): number {
  let n = 0
  doc.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((a) => {
    if (hasJQueryClick(jq, a)) return
    a.addEventListener('click', (e) => {
      const target = resolveAnchorTarget(doc, a.hash)
      if (!target) return
      const top = jq(target).offset()?.top
      if (top == null) return
      jq('html,body').animate({ scrollTop: top + SCROLL_OFFSET_Y }, SCROLL_TIME_MS, 'swing')
      window.history.pushState(null, '', a.hash)
      e.preventDefault()
      e.stopPropagation()
    })
    n++
  })
  return n
}

export default function anchorScroll(): void {
  const jq = (window as unknown as { jQuery?: JQ }).jQuery
  if (typeof jq !== 'function') return
  // 旧実装（jQuery ready で束ねる）より後に走らせないと、上の判定の時点でまだ旧のハンドラが無く二重に束ねてしまう
  afterOldScripts(() => bindAnchorScroll(document, jq))
}
